const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class CollectionControls extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.collectionWrapper = document.querySelector("[data-collection]");
    this.collectionCount = document.querySelector("[data-collection-count]");
    this.sectionId = this.dataset.sectionId;
    this.select = this.querySelector("#SortBy");
    this.formInputRadios = this.form.querySelectorAll("input[type='radio'");
    this.formInputs = this.form.querySelectorAll("input");
    this.resetBtn = this.querySelector("[data-reset]");
    this.closeBtn = this.querySelector("[data-close]");
    this.applyBtn = this.querySelector("[data-apply]");
  }

  connectedCallback() {
    this.addEventListener(
      "change",
      debounce(() => {
        this.submitHandler();
      }, 500),
    );

    this.applyBtn.addEventListener("click", () => {
      this.dispatchEvent(
        new CustomEvent("conditional-details:close", {
          bubbles: true,
        }),
      );
    });

    this.resetBtn.addEventListener("click", () => {
      this.resetUrl();
      this.resetForm();
    });

    this.closeBtn.addEventListener("click", () => {
      this.dispatchEvent(
        new CustomEvent("conditional-details:close", {
          bubbles: true,
        }),
      );
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  submitHandler() {
    const searchParams = this.createSearchParams(this.form);

    this.submitForm(searchParams);
  }

  submitForm(searchParams) {
    const queryString = searchParams.toString();
    const url = `${window.location.pathname}?section_id=${this.sectionId}${queryString ? `&${queryString}` : ""}`;
    this.fetchCollection(url);
    this.updateURLHash(queryString);
  }

  resetUrl() {
    this.submitForm(new URLSearchParams());
  }

  resetForm() {
    this.formInputs.forEach((input) => {
      if (input.type === "radio" || input.type === "checkbox") {
        input.checked = false;
      }
    });
  }

  fetchCollection(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const newCount = parsedHTML.querySelector(
          "[data-collection-count]",
        ).innerHTML;
        const newWrapper = parsedHTML.querySelector("[data-collection]");
        this.collectionCount.innerHTML = newCount;
        this.collectionWrapper.innerHTML = newWrapper.innerHTML;
      });
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }
}

if (!customElements.get("collection-controls")) {
  customElements.define("collection-controls", CollectionControls);
}
